import $ from 'jquery';
import Slider, {
  attachPaginationEvents,
  cssClassLazyloadOnSlide,
  cssClassSwiperDuplicate,
  cssClassSwiperSlide,
  lazyLoadImage,
} from '../../js/modules/Slider.mjs';
import {
  gridBreakpoints,
  gridGutterWidth,
} from '../../js/utilities/media-queries.mjs';
import {CSS_CLASS_ANIMATED_LINE} from '../../js/Ui.mjs';

const namespace = 'CollectionTeaserLine';
const $sliders = $('.js_ef-collection-teaser-line');

$sliders.each((index, slider) => {
  const $slider = $(slider);
  const $sliderWrapper = $slider.find('.ef-collection-teaser-line__slider-wrapper');
  const $sliderSlides = $slider.find('.ef-collection-teaser-line__slider-slide');
  const $slidesContents = $sliderSlides.find('.ef-teaser-line__content-holder');

  const SliderCollectionTeaserLine = new Slider({
    namespace: namespace,
    sliderNode: slider,
    $wrapper: $sliderWrapper,
    swiperConfigOverride: {
      autoHeight: true,
      breakpoints: {
        [gridBreakpoints.xs]: {
          slidesPerView: 1,
          spaceBetween: gridGutterWidth
        },
        [gridBreakpoints.md]: {
          slidesPerView: 2,
          spaceBetween: gridGutterWidth
        },
        [gridBreakpoints.lg]: {
          slidesPerView: 3,
          spaceBetween: gridGutterWidth
        }
      },
      on : {
        init() {
          // Workaround line animation, when Swiper duplicates slides
          $slider.find(`.${cssClassSwiperDuplicate} ${CSS_CLASS_ANIMATED_LINE}`).addClass('-animate');
        },
        lazyImageLoad: lazyLoadImage,
        paginationRender(swiper) {
          attachPaginationEvents(swiper);
        },
      },
    },
    callbacks: {
      onInitStart() {
        $sliderWrapper.addClass('no-gutters');
        $sliderSlides.addClass(cssClassSwiperSlide);

        // Set min height to content if necessary
        const needMinHeight = $slidesContents.toArray().some((content) => $(content).outerHeight() >= 300);
        if (needMinHeight) {
          $slidesContents.addClass('-min-height');
        }

        /*
         * Recalculate height of slider, since the logos doesn't reserve height
         * It's save to assume that Swiper is initiated, since the image are
         * lazy loaded by Swiper.
         */
        const $firstLogo = $sliderSlides.first().find('.ef-teaser-line__logo img');

        $firstLogo.on('load.' + namespace, () => {
          SliderCollectionTeaserLine.slider.swiper.updateAutoHeight();

          $firstLogo.off('load.' + namespace);
        });
      },
      onDestroy() {
        $sliderWrapper.removeClass('no-gutters');
        $sliderSlides.removeClass(cssClassSwiperSlide);
      },
    },
  });

  if (SliderCollectionTeaserLine.slidesDontFitIntoWrapper()) {
    SliderCollectionTeaserLine.init();
  } else {
    $slider.find(`.${cssClassLazyloadOnSlide}`).addClass('lazyload');
  }
  SliderCollectionTeaserLine.attachResize();
});
